<template>
  <v-autocomplete
    variant="outlined"
    density="compact"
    v-model="inputValue"
    v-bind:items="disabilitys"
    v-bind:item-title="(item) => objectTranslator(item, 'DISABILITY_NAME')"
    v-bind:item-value="(item) => item.DISABILITY_ID"
    v-bind:rules="rules"
  ></v-autocomplete>
</template>
<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

export default {
  name: "DisabilityCard",
  props: {
    modelValue: String,
  },

  data: () => ({
    rules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    disabilitys: function () {
      return this.$store.state.ref.disabilitys;
    },

    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getDisabilitys");
  },
};
</script>
